import axios from 'axios'

const ReceivingService = {
  async get (params = {}) {
    return axios.get('lo/delivery-receivings', { params })
  },

  async histories (params = {}) {
    return axios.get('lo/reports/delivery-receiving-histories', { params })
  },

  async show (id) {
    return axios.get(`lo/delivery-receivings/${id}`)
  },

  async post (params = {}) {
    return axios.post('lo/delivery-receivings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`lo/delivery-receivings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`lo/delivery-receivings/${data.id}`, { data })
  }
}

export default ReceivingService
